// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__132ry","modalFooterButton":"ModalNotes_modalFooterButton__18676"};